var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { stringify } from 'query-string';
export const accountPlansDataProvider = context => {
    const basePath = `${context.apiUrl}/api-management/1.0/account-plans`;
    return {
        getList: async ({ filter = {}, pagination = { page: 1, perPage: 24 }, sort = null, }) => {
            const url = `${context.apiUrl}${basePath}?${stringify(Object.assign(Object.assign(Object.assign({}, filter), { page: pagination.page - 1, size: pagination.perPage }), (sort && { sort: `${sort.field},${sort.order}` })))}`;
            const { json } = await context.fetchJson(url, {
                credentials: 'include',
            });
            return {
                data: json.results.map((_a) => {
                    var { uuid } = _a, item = __rest(_a, ["uuid"]);
                    return (Object.assign({ id: uuid }, item));
                }) || [],
                total: json.totalElements || 0,
            };
        },
        getOne: async ({ id }) => {
            const url = `${context.apiUrl}${basePath}/${id}`;
            const { json } = await context.fetchJson(url, {
                credentials: 'include',
            });
            return {
                data: Object.assign({ id }, json),
            };
        },
    };
};
//# sourceMappingURL=accountPlans.js.map